export default "__VITE_ASSET__D84Vudvi__"